// Pure helpers for deriving the per-chat note template without useChats context.
// Ported verbatim from useChats.js so RenderedNote can render an arbitrary chat
// (e.g., the EHR Templates Edit page's executionChat) without going through the
// chat-edit hook context.

// `auth` is unused here but kept for symmetry with getNoteTemplateForChat —
// callers can spread the same args to both helpers without conditional logic.
// eslint-disable-next-line no-unused-vars
export function hasNewTemplateForChat(chat, auth) {
  if (!chat?.contextVariables?.["local:noteDesign"]) return false;
  try {
    return !chat.contextVariables["local:noteDesign"].sections.some((s) => s.variable === undefined);
  } catch (e) {
    console.error("Section not valid ", chat.contextVariables["local:noteDesign"].sections);
    console.error(e);
    return false;
  }
}

export function getNoteTemplateForChat(chat, auth) {
  if (hasNewTemplateForChat(chat, auth)) {
    const encounterType = chat.contextVariables["local:encounterType"];
    const designSections = chat.contextVariables["local:noteDesign"]?.sections || [];
    const storedSections = auth?.user?.custom?.noteSections?.[encounterType] || [];

    let mergedSections = designSections.map((section) => {
      const isSeparator = section.variable?.startsWith("separator");
      let title = section?.title;

      if (section.title_i18n && auth?.user?.custom?.noteLanguage && auth?.user?.custom.noteLanguage !== "en") {
        title = section.title_i18n;
      }

      return {
        title: isSeparator ? "" : title,
        variable: section.variable,
        exclude: false,
        isSeparator,
      };
    });

    if (storedSections.length > 0) {
      const used = new Set();
      const reordered = [];

      for (const stored of storedSections) {
        if (!stored?.variable) continue;
        const matchingSection = mergedSections.find((section) => section.variable === stored.variable);
        if (!matchingSection) continue;

        reordered.push({
          ...matchingSection,
          exclude: stored.exclude ?? false,
          isSeparator: stored.isSeparator ?? matchingSection.isSeparator,
        });
        used.add(stored.variable);
      }

      const remaining = mergedSections.filter((section) => !used.has(section.variable));
      mergedSections = [...reordered, ...remaining];
    }

    const defaults = auth?.user?.custom?.noteSections?.default || {};
    return mergedSections.map((section) => {
      if (defaults[section.variable]) {
        let title = section.title;
        if (auth?.user?.custom?.noteLanguage && auth?.user?.custom.noteLanguage !== "en") {
          if (defaults[section.variable]["title_" + auth.user.custom.noteLanguage]) {
            title = defaults[section.variable]["title_" + auth.user.custom.noteLanguage];
          }
        } else {
          if (defaults[section.variable].title) {
            title = defaults[section.variable].title;
          }
        }

        return {
          ...section,
          exclude: defaults[section.variable].exclude ?? section.exclude,
          title,
          title_i18n: title,
        };
      }
      return section;
    });
  } else {
    return auth?.user?.custom?.noteSettings?.[chat?.contextVariables?.["local:encounterType"]]?.sections || null;
  }
}
